import * as ng from 'angular';
import './chart-bar';

export class AtomChartBarController implements ng.IController {
    public static $inject: string[] = [];

    public reachedPercentage: number;
    public ignoreStatusModifier = false;

    public setTotalPercentage = (): number => {
        return this.reachedPercentage > 100 ? 100 : this.reachedPercentage;
    };

    public setModifier = (percent: number): string => {
        const modifierMap = {
            high: 'value-is-high',
            low: 'value-is-low',
            medium: 'value-is-medium'
        };

        if (Number(percent) && !this.ignoreStatusModifier) {
            switch (true) {
                // 80+
                case (Number(percent) > 80):
                    return modifierMap.high;
                // 50-80
                case (Number(percent) > 50 && Number(percent) <= 80):
                    return modifierMap.medium;
                // 0-50
                default:
                    return modifierMap.low;
            }
        }

        return modifierMap.low;
    };
}

export class AtomChartBarComponent implements ng.IComponentOptions {
    public bindings = {
        ignoreStatusModifier: '<?',
        reachedPercentage: '<'
    };

    public controller =  AtomChartBarController;
    public template = require('./chart-bar.html');
}
